/* eslint-disable max-len */
import { createSlice } from '@reduxjs/toolkit';
import { current } from 'immer';

const initialState = {
	// Define your initial state here
	userInfo                : {},
	add_onsData             : null,
	presenceUserChatList    : [],
	chatRoomInfo            : {},
	callDetails             : null,
	chatMessages            : [],
	userAutoDownloadSetting : null,
	userStatus              : '',
	pluginRating            : {},
	isFireBaseAuth          : '',
	groupIds                : {},
	broadcastList           : [],
	isChatLoaded           	: false,
	currentUserSettings     : null, // Current user's settings (read receipts, privacy, notifications, etc.)
	peerUserSettings        : null, // Peer user's settings (read receipts, online status, privacy, etc.)
	peerUserId              : null, // Track which peer we're currently listening to
	uploadDialogFlag        : false // Global flag to prevent multiple upload dialogs

};

export const presenceSlice = createSlice({
	name     : 'presence',
	initialState,
	reducers : {
		// Define your reducer functions here
		setUserInfo : (state, action) =>
		{
			state.userInfo = action.payload;
		},
		setAddOnsData : (state, action) =>
		{
			state.add_onsData = action.payload;
		},
		setPresenceChatUserList : (state, action) =>
		{
			state.presenceUserChatList = [ ...action.payload ];
		},
		setChatRoomInfo : (state, action) =>
		{
			state.chatRoomInfo = action.payload;
		},
		setCallDetails : (state, action) =>
		{
			state.callDetails = action.payload;
		},
		// resetUserInfo : () =>
		// {
		// 	return initialState;
		// },
		setChatMessages : (state, action) =>
		{
			state.chatMessages = action.payload;
		},
		setEachMessage : (state, action) =>
		{
			const messageRoomId = action?.payload?.broadcastId || action?.payload?.chatId;
			if (messageRoomId && state?.chatRoomInfo?.id && state.chatRoomInfo.id !== messageRoomId)
			{
				return;
			}
			const copyData = [ ...state.chatMessages ];
			const index = copyData?.findIndex((each) => each?.id === action.payload.id);
			// if(state.chatRoomInfo?.id === action.payload?.chatId){

			if (index === -1)
			{
				copyData.push(action.payload);
			}
			else
			{
				copyData.splice(index, 1, action.payload);
			}
			state.chatMessages = [ ...copyData ];
		},
		setEachCallDetailChanges : (state, action) =>
		{
			// userInfo is not being used anywhere, it has no data in it
			const { callId, groupId, status } = action.payload;

			if (state.chatRoomInfo?.id === groupId)
			{
				const copyData = [ ...state.chatMessages ];
				// Find the index of the message with matching callId
				const index = copyData?.findIndex((each) => each?.id === callId);

				if (index === -1)
				{
					return;
				}
				// Access the plain object version of the current message
				const currentMsg = current(copyData[index]);
				// Safely update the callDetails -> participants -> userId -> status
				const finalObj = {
					...currentMsg,
					callDetails : {
						...currentMsg?.callDetails,
						participants : {
							...currentMsg?.callDetails?.participants,
							[state.userInfo.userId] : {
								...currentMsg?.callDetails?.participants?.[state.userInfo.userId],
								status
							}
						}
					}
				};
				// Update the message in the array

				copyData[index] = finalObj;

				// // Reassign the updated messages back to state
				state.chatMessages = [ ...copyData ];
			}
		},
		setuserAutoDownloadSetting : (state, action) =>
		{
			state.userAutoDownloadSetting = action.payload;
		},
		setUserStatus : (state, action) =>
		{
			state.userStatus = action.payload;
		},
		setisFireBaseAuth : (state, action) =>
		{
			state.isFireBaseAuth = action.payload;
		},
		setPresenceChatUser : (state, action) =>
		{
			const updatedObject = action.payload;

			state.presenceUserChatList = state.presenceUserChatList.map((chat) =>
				(chat.id === updatedObject.id ? { ...chat, ...updatedObject } : chat)
			);
		},
		setGroupIds : (state, action) =>
		{
			state.groupIds = action.payload;
		},
		setBroadcastChatUserList : (state, action) =>
		{
			state.broadcastList = [ ...action.payload ];
		},
		setIsChatLoaded : (state, action) =>
		{
			state.isChatLoaded = action.payload;
		},
		setBroadcastChatUser : (state, action) =>
		{
			const updatedObject = action.payload;

			state.broadcastList = state.broadcastList.map((chat) =>
				(chat.id === updatedObject.id ? { ...chat, ...updatedObject } : chat)
			);
		},
		setBroadcastChatUserUpdate : (state, action) =>
		{
			const copyData = [ ...state.broadcastList ];
			const index = copyData?.findIndex((each) => each?.id === action.payload.id);

			if (index !== -1)
			{
				copyData.splice(index, 1); // Remove existing entry if it exists
			}

			// Add the new data at the beginning of the array
			copyData.unshift(action.payload?.data);

			state.broadcastList = [ ...copyData ];
		},
		// setBroadcastChatUserUpdate : (state, action) =>
		// {
		// 	const copyData = [ ...state.broadcastList ];
		// 	const index = copyData?.findIndex((each) => each?.id === action.payload.id);
		// 	// if(state.chatRoomInfo?.id === action.payload?.chatId){

		// 	if (index === -1)
		// 	{
		// 		copyData.push(action.payload?.data);
		// 	}
		// 	else
		// 	{
		// 		copyData.splice(index, 1, action.payload?.data);
		// 	}
		// 	state.broadcastList = [ ...copyData ];
		// }
		setCurrentUserSettings : (state, action) =>
		{
			state.currentUserSettings = action.payload;
		},
		setPeerUserSettings : (state, action) =>
		{
			state.peerUserSettings = action.payload;
		},
		setPeerUserId : (state, action) =>
		{
			state.peerUserId = action.payload;
		},
		setUploadDialogFlag : (state, action) =>
		{
			state.uploadDialogFlag = action.payload;
		},
		resetPresenceRedux : (_state) =>
		{
			return initialState;
		}

	} });

export const {
	setAddOnsData,
	setPresenceChatUserList,
	setChatRoomInfo,
	setCallDetails,
	setChatMessages,
	setEachMessage,
	setEachCallDetailChanges,
	setuserAutoDownloadSetting,
	setUserStatus,
	setisFireBaseAuth,
	setPresenceChatUser,
	setGroupIds,
	setBroadcastChatUserList,
	setIsChatLoaded,
	setBroadcastChatUser,
	setBroadcastChatUserUpdate,
	setCurrentUserSettings,
	setPeerUserSettings,
	setPeerUserId,
	setUploadDialogFlag,
	resetPresenceRedux
} = presenceSlice.actions;
export default presenceSlice.reducer;